import React from "react"
import { Card, CardBody, Row, Col } from "reactstrap"
import {
  change,
  Field,
  FieldArray,
  formValueSelector,
  getFormSyncErrors,
  setSubmitFailed,
} from "redux-form"
import ImageEditor from "components/ImageEditor"
import ColorPicker from "components/ColorPicker"
import { RichTextField, SingleSelectField } from "components/RenderInput"
import { SaveButton } from "components/Buttons"
import { renderListItemButtons } from "./utils"
import { connect } from "react-redux"
import { FORM_NAMES } from "constants/index"
import { FONTS } from "constants/fonts"

const ListItemPopup = ({
  closeHandler,
  listItem,
  formSyncErrors,
  itemIndex,
  change,
  formValues,
  touch,
}) => {
  return (
    <Card>
      <CardBody>
        <Row>
          <Col>
            <h5>
              Here you have the ability to create additional content for your
              list item. You have the option to add up to 4 buttons with web
              links. You also have the option to add extra details via the text
              box below.
            </h5>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <FieldArray
              name={`${listItem}.listItemButtons`}
              component={renderListItemButtons}
              listItem={listItem}
            />
          </Col>
        </Row>
        <Row className="my-3">
          <Col xl={3}>Background Image:</Col>
          <Col xl={9}>
            <Field
              name={`${listItem}.backgroundImage`}
              component={ImageEditor}
              onDelete={() =>
                change(`list_form.${listItem}.deleteBackgroundImage`, true)
              }
            />
          </Col>
        </Row>
        <Row className="my-3">
          <Col xl={3}>Background Color:</Col>
          <Col xl={9}>
            <Field
              name={`${listItem}.backgroundColor`}
              component={ColorPicker}
            />
          </Col>
        </Row>
        <Row className="my-3">
          <Col xl={3}>Font Family:</Col>
          <Col xl={9}>
            <Field
              name={`${listItem}.fontFamily`}
              fullWidth={true}
              component={SingleSelectField}
              className="full-width"
              options={FONTS.map(font => ({
                value: font.value,
                label: font.text,
              }))}
            />
          </Col>
        </Row>
        <Row className="my-3">
          <Col xl={3}>Text and Icon Color:</Col>
          <Col xl={9}>
            <Field name={`${listItem}.textColor`} component={ColorPicker} />
          </Col>
        </Row>
        <Row className="my-3">
          <Col xl={12}>Extra Details (optional):</Col>
          <Col xl={12} className="mt-1">
            <Field
              name={`${listItem}.details`}
              component={RichTextField}
              backgroundColor={formValues[itemIndex].backgroundColor}
              textColor={formValues[itemIndex].textColor}
              backgroundImage={
                formValues[itemIndex]?.backgroundImage?.editedImage
              }
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <SaveButton
              type="button"
              content="Done"
              onClick={() => {
                if (
                  !(
                    formSyncErrors.hasOwnProperty("list_form") &&
                    formSyncErrors.list_form.hasOwnProperty("listItems") &&
                    formSyncErrors.list_form.listItems.hasOwnProperty(
                      itemIndex.toString()
                    ) &&
                    formSyncErrors.list_form.listItems[
                      itemIndex
                    ].hasOwnProperty("listItemButtons")
                  )
                ) {
                  closeHandler()
                } else {
                  touch(`list_form.listItems[${itemIndex}]`)
                }
              }}
            />
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

const selector = formValueSelector(FORM_NAMES.LIST)

const mapStateToProps = state => ({
  formSyncErrors: getFormSyncErrors(FORM_NAMES.LIST)(state),
  formValues: selector(state, "list_form.listItems"),
})

const mapDispatchToProps = dispatch => ({
  change: (field, value) => dispatch(change(FORM_NAMES.LIST, field, value)),
  touch: fields => dispatch(setSubmitFailed(FORM_NAMES.LIST, fields)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ListItemPopup)
